import { createApp, nextTick } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import { pinia } from '@/plugins/pinia';
import i18n from '@/plugins/i18n';
import { useLanguageStore } from '@/stores/utils/language';
import { scrollShadow } from '@/directives/scrollable-content';
import { tooltip } from '@/directives/tooltip';
import "@/scss/style.scss";

const app = createApp(App);

app.use(router);
app.use(pinia);
app.use(i18n);

app.directive('scroll-shadow', scrollShadow);
app.directive('tooltip', tooltip);

const languageStore = useLanguageStore();

if (process.env.VUE_APP_TYPE !== 'builder') {
    const { register: registerSwiper } = require('swiper/element/bundle');
    registerSwiper();
}

if (process.env.VUE_APP_TYPE === 'developers') {
    Promise.all([
        import('highlight.js/lib/core'),
        import('highlight.js/lib/languages/json'),
        import('highlight.js/styles/github-dark.css')
    ]).then(([hljsModule, jsonModule]) => {
        const hljs = hljsModule.default;
        hljs.registerLanguage('json', jsonModule.default);
        app.directive('highlight', {
            mounted(el) {
                nextTick(() => {
                    const blocks = el.querySelectorAll('pre code');
                    blocks.forEach(block => {
                        const text = block.textContent;
                        block.textContent = text;
                        block.removeAttribute('data-highlighted');
                        hljs.highlightElement(block);
                    });
                });
            },
            updated(el) {
                nextTick(() => {
                    const blocks = el.querySelectorAll('pre code');
                    blocks.forEach(block => {
                        const text = block.textContent;
                        block.textContent = text;
                        block.removeAttribute('data-highlighted');
                        hljs.highlightElement(block);
                    });
                });
            }
        });

        languageStore.initLocale().then(() => {
            app.mount('#app');
        });
    });
} else if (process.env.VUE_APP_TYPE === 'search') {
    import('vue-recaptcha-v3')
        .then(module => {
            const { VueReCaptcha } = module;
            app.use(VueReCaptcha, {
                siteKey: '6LeNydAlAAAAAFBXDbkgVqUlWr6qPFxMvVzFpU8w',
                loaderOptions: {
                    autoHideBadge: true,
                },
            });
        })
        .finally(() => {
            languageStore.initLocale().then(() => {
                app.mount('#app');
            });
        });
} else {
    languageStore.initLocale().then(() => {
        app.mount('#app');
    });
}